import { render } from "./MenuPromoPopup.vue?vue&type=template&id=3b4547e6&scoped=true"
import script from "./MenuPromoPopup.vue?vue&type=script&lang=js"
export * from "./MenuPromoPopup.vue?vue&type=script&lang=js"

import "./MenuPromoPopup.vue?vue&type=style&index=0&id=3b4547e6&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4547e6"]])

export default __exports__